/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-03-10 15:30:36
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-05-12 09:19:28
 */
/*
* 权限管理
* */
export default [
    // 组织维护
    // {
    //     path : '/organizationMt',
    //     name : 'organizationMt',
    //     component : resolve => {
    //         require(['components/System/organizationMt.vue'], resolve);
    //     },
    //     meta : {
    //         // login : true,
    //         title : '组织维护'
    //     }
    // },
    // 组织维护
    {
        path : '/organizationMtList',
        name : 'organizationMtList',
        component : resolve => {
            require(['components/System/organizationMtList.vue'], resolve);
        },
        meta : {
            // login : true,
            title : '组织管理'
        }
    },
    // 角色维护
    {
        path : '/roleMt',
        name : 'roleMt',
        component : resolve => {
            require(['components/System/roleMt.vue'], resolve);
        },
        meta : {
            // login : true,
            title : '角色维护'
        }
    },
    // 模块维护
    {
        path : '/moduleMt',
        name : 'moduleMt',
        component : resolve => {
            require(['components/System/moduleMt.vue'], resolve);
        },
        meta : {
            // login : true,
            title : '模块维护'
        }
    },
    // 用户维护
    {
        path : '/userMt',
        name : 'userMt',
        component : resolve => {
            require(['components/System/userMt.vue'], resolve);
        },
        meta : {
            // login : true,
            title : '用户维护'
        }
    },
    // 机构用户维护
    {
        path : '/organUser',
        name : 'organUser',
        component : resolve => {
            require(['components/System/organUser.vue'], resolve);
        },
        meta : {
            // login : true,
            title : '机构用户'
        }
    },
    // 文件模版维护
    {
        path : '/fileTemplateMt',
        name : 'fileTemplateMt',
        component : resolve => {
            require(['components/FileManage/powerList.vue'], resolve);
        },
        meta : {
            // login : true,
            title : '文件模版'
        }
    },
    // 文件模版授权
    {
        path : '/fileTemplateMt/setPower/:id',
        name : 'fileSetPower',
        component : resolve => {
            require(['components/FileManage/powerList.vue'], resolve);
        },
        meta : {
            login : false,
            title : '文件模版授权'
            // keppAlive : true
        }
    },
    // 系统升级管理
	{
		path : '/systemUpdate',
		name : 'systemUpdate',
		component : resolve => {
			require(['components/System/systemUpdate.vue'], resolve);
		},
		meta : {
				// login : true,
			title : '系统升级管理'
		}
    },
    // 数据字典管理
	{
		path : '/dictManage',
		name : 'dictManage',
		component : resolve => {
			require(['components/System/dictManage.vue'], resolve);
		},
		meta : {
				// login : true,
			title : '数据字典管理'
		}
    },
    // 系统参数管理
	{
		path : '/sysParameterManage',
		name : 'sysParameterManage',
		component : resolve => {
			require(['components/System/sysParameterManage.vue'], resolve);
		},
		meta : {
				// login : true,
			title : '系统参数管理'
		}
    },
    // 缓存刷新
	{
		path : '/cacheRefreshManage',
		name : 'cacheRefreshManage',
		component : resolve => {
			require(['components/System/cacheRefreshManage.vue'], resolve);
		},
		meta : {
				// login : true,
			title : '缓存刷新'
		}
    },
    // 应用管理
	{
		path : '/applyManage',
		name : 'applyManage',
		component : resolve => {
			require(['components/System/applyManage.vue'], resolve);
		},
		meta : {
				// login : true,
			title : '应用管理'
		}
    },
    // 模版管理
	{
		path : '/applyTemplateManage',
		name : 'applyTemplateManage',
		component : resolve => {
			require(['components/System/applyTemplateManage.vue'], resolve);
		},
		meta : {
				// login : true,
			title : '缓存刷新'
		}
	},
     // 网格管理
	{
		path : '/gridManagement',
		name : 'gridManagement',
		component : resolve => {
			require(['components/System/gridManagement.vue'], resolve);
		},
		meta : {
				// login : true,
			title : '网格管理'
		}
  },
  	{
		path : '/addressManagement',
		name : 'addressManagement',
		component : resolve => {
			require(['components/System/addressManagement.vue'], resolve);
		},
		meta : {
				// login : true,
			title : '网格管理'
		}
	},
  // 机构参数配置
  {
    path : '/cfOrgConfig',
    name : 'cfOrgConfig',
    component : resolve => {
      require(['components/System/cfOrgConfig.vue'], resolve);
    },
    meta : {
      // login : true,
      title : '机构参数配置'
    }
  },
  // 三方机构配置
  {
    path : '/cfThirdOrg',
    name : 'cfThirdOrg',
    component : resolve => {
      require(['components/System/cfThirdOrg.vue'], resolve);
    },
    meta : {
      // login : true,
      title : '三方机构配置'
    }
  },
  // 地域管理
  {
    path : '/regionManage',
    name : 'regionManage',
    component : resolve => {
      require(['components/System/regionManage.vue'], resolve);
    },
    meta : {
      // login : true,
      title : '地域管理'
    }
  },
  // 地图测试
  {
    path : '/mapDialog',
    name : 'mapDialog',
    component : resolve => {
      require(['components/System/mapDialog.vue'], resolve);
    },
    meta : {
      // login : true,
      title : '地域管理'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routers/system.js